import React from "react";
import "./Product_ifile22.css";

function Product_ifile22() {
  return (
    <div className="tpms-top-section">

      {/* HERO SECTION */}
      <section className="tpms-hero">

        <div className="tpms-hero-left px-5">

          <h1 className="tpms-title-ifile">
            {/* <span>IFile Management System</span> */}
            <span>iTixFile management System</span>
          </h1>

          <p className="tpms-desc fw-bold text-justify">
           iTixFiles helps individuals and organizations organize documents, manage applications, digitize paper records and track work from submission to completion — all in one connected workspace.
          </p><br></br>
          <p className="tpms-desc fw-bold text-justify">Designed with the needs of India in mind, iTixFiles brings digital file management, electronic workflows and ticketing together to reduce paperwork, repeated data entry, delays and scattered records.</p>


          <div className="tpms-buttons">
            <button className="tpms-demo-btn">Request Demo</button>
            <button className="tpms-video-btn tpms-demo-btn">Contact Our Team</button>
          </div>

        </div>

        <div className="tpms-hero-right">
            <div className="tpms-image-wrapper">
              <div className="bgg3">
                {/* Using a placeholder for demo. Replace with your actual image path e.g., "ImagesNew/dashboard-LR-1.jpeg" */}
                <img
                src="ImagesNew/ifile_heroimg.jpg" 
                alt="ifile_dashboard"
                className="tpms-hero-img"
                />
                </div>
            </div>
        </div>

      </section>

      {/* STATS BAR */}
      {/* <section className="tpms-stats">

        <div className="tpms-stats-box">
          <h3>97%</h3>
          <p>Accuracy</p>
        </div>

        <div className="tpms-stats-box">
          <h3>21s</h3>
          <p>Response Time</p>
        </div>

        <div className="tpms-stats-box">
          <h3>25%</h3>
          <p>Fuel Saving</p>
        </div>

        <div className="tpms-stats-box">
          <h3>120+</h3>
          <p>Fleet Monitoring</p>
        </div>

        <div className="tpms-stats-box">
          <h3>100%</h3>
          <p>Safety</p>
        </div>

      </section> */}

    </div>
  );
}

export default Product_ifile22;